<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingTecnicos"
        @add="$router.push({ path: '/tecnico' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Nome, CPF, E-mail ou Identificador" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm12 xs12 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingTecnicos"
                    :must-sort="true" :items="tecnicos" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'
import { formatCPF } from '@/filters/utils'

const toTecnicoView = entry => {
    let nrDocumento = formatCPF(entry.nrDocumento)

    return {...entry, nrDocumento}
}

export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idResponsavelTecnico', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Extensionistas',
        registroSelected: '',
        headers: [            
            { text: 'Nome', value: 'nmPessoa' },
            { text: 'CPF', value: 'nrDocumento' },
            { text: 'E-mail', value: 'stEmail' },
            { text: 'Identificador', value: 'idResponsavelTecnico' },
        ],
        tecnicos: [],
        isLoadingTecnicos: false,
        isErrorTecnico: false,
        query: {},
        search: '',
    }),
    methods: {
        formatCPF,
        initViewFromRoute(route) {
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'tecnico', params: { id : value.idResponsavelTecnico } })
        },
        searchItem() {
            var search = Object.assign({}, this.query)

            this.isLoadingTecnicos = true

            this.$axios.get('responsavel-tecnico/', { params: search })
            .then((response) => {
                this.tecnicos = response.data[0].data ? response.data[0].data.map(toTecnicoView) : []
            })
            .catch((error) => {
                this.isErrorTecnico = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingTecnicos = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'tecnicoSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
